export default "__VITE_ASSET__ea0c37ef__"